export default "__VITE_ASSET__DPOX9XoJ__"